import React, { Component } from 'react'
import Styles from './style.module.less'
import { observer } from 'mobx-react'
import store from './store'
import { HeaderView } from '@merchant-backend/common-components'
import { BOND_PATH_A } from '@constant'

@observer
export default class extends Component {
  componentDidMount() {
    store.getData()
  }

  render() {
    let {
      msg: { desc, account, butShow }
    } = store

    return (
      <HeaderView title="消费者保障计划">
        <div className={Styles.container}>
          <div className={Styles.bond}>
            <div className={Styles.num}>放心购·保证金余额：{account}元</div>
            <div className={Styles.desc}>{desc}</div>
            <a
              className={Styles.fillin}
              style={{ display: butShow ? 'block' : 'none' }}
              href={`${BOND_PATH_A}`}
            >
              立即缴纳
            </a>
          </div>

          <div className={Styles.educate}>
            <img src="https://qnm.hunliji.com/o_1cuasdbii1aue1rin15621f1n1mhhh.jpg" />
            <img src="https://qnm.hunliji.com/o_1cuasdbiifva193q1f2bub81m68i.jpg" />
            <img src="https://qnm.hunliji.com/o_1cuasdbii7u8pj21kme11ue1g59j.jpg" />
          </div>
        </div>
      </HeaderView>
    )
  }
}
